import { breakpoints } from "../_styleguide/_breakpoints";
import DashboardParams from "./dashboard.params";
import DashboardHTMLV2 from "./dashboard.html.v2";
import DashboardInteractions from "./dashboard.interactions";
import DashboardData from "./dashboard.data.service";
import DashboardGraph from "./dashboard.graph.service";
import DataStore from '../data.store';
import { screenType } from './dashboard.resize';
var InitDashboard = /** @class */ (function () {
    function InitDashboard() {
        this.graphObjectArray = [];
        this.params = new DashboardParams();
        this.interactions = new DashboardInteractions(this, this.params);
        this.dataStore = new DataStore();
        this.dataService = new DashboardData();
        this.graphService = new DashboardGraph(this);
        this.html = new DashboardHTMLV2(this, this.interactions, this.dataService);
    }
    InitDashboard.prototype.init = function () {
        var self = this;
        this.reloadHtml();
        var _a = this.params.read(), params = _a.params, segment = _a.segment;
        var dashboardArray = this.params.matchConfig(params.topic);
        this.interactions.updateMenuList(params.topic);
        this.call(params.topic, dashboardArray, segment, false);
        var screen = screenType(window.innerWidth);
        window.addEventListener("resize", function () {
            var newScreen = screenType(window.innerWidth);
            if (screen != newScreen) {
                setTimeout(function () {
                    self.reloadHtml();
                }, 100);
            }
        }, false);
        // setTimeout( () => {
        //     window.dispatchEvent(new Event('resize'));
        // }, 1000);
    };
    InitDashboard.prototype.reloadHtml = function () {
        this.htmlContainer = this.html.styleParentElement();
        [].slice.call(document.getElementsByTagName("aside")).forEach(function (a) { return a.remove(); });
        [].slice.call(document.getElementsByTagName("nav")).forEach(function (a) { return a.remove(); });
        if (window.innerWidth >= breakpoints.lg) {
            var aside = this.html.createSideBar(this.htmlContainer);
            aside.insertBefore(this.html.createMenu(this.htmlContainer), aside.childNodes[0]);
        }
        else {
            var mobileNavTop = this.html.createMobileNav(this.htmlContainer);
            // let mobileNavBottom = this.html.createMobileNav(this.htmlContainer);
        }
        this.html.createPopupElement();
    };
    InitDashboard.prototype.call = function (topic, dashboardArray, segment, update) {
        this.html.pageHeader(topic, this.htmlContainer);
        this.graphService.call(topic, dashboardArray, segment, update, this.htmlContainer);
    };
    return InitDashboard;
}());
export { InitDashboard };
